import axios from 'axios';

const BASE_URL = process.env.VUE_APP_APIURL;

const getReportsHistory = (reportId, pageSize = 10, pageNum = 1) => axios.get(`${BASE_URL}/api/Archive/Reports/${reportId}?pageSize=${pageSize}&pageNum=${pageNum}`);
const getVehicleContractHistory = (id, pageSize = 10, pageNum = 1) => axios.get(`${BASE_URL}/api/Archive/VehicleContracts/${id}?pageSize=${pageSize}&pageNum=${pageNum}`);
const getVehicleHistory = (id, pageSize = 10, pageNum = 1) => axios.get(`${BASE_URL}/api/Archive/Vehicles/${id}?pageSize=${pageSize}&pageNum=${pageNum}`);

export default {
    getHistory: getReportsHistory,
    getVehicleContractHistory,
    getVehicleHistory,
};
